window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.Popper = require('@popperjs/core');

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// Or import only needed plugins
import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;

//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;

//=====================================
//Swiper
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
// main.js（最初に貼っていたコードの末尾などに追加）
import { initMarquee } from './inc_marquee';
import { initSlotNumber } from './inc_slotNumber';
import { registerChartTheme01 } from './inc_theme_chart01';
import { initGsapAnimations } from './inc_inc_gsapScrollAnim.js';

/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
window.App = window.App || {};
window.App.loadSectionId = function (sourceID, modalId, modalTitle) {
  var $sourceEl = $('#' + sourceID); // IDとして扱う
  const $modal = $(modalId);
  const $output = $modal.find('.ajx_content_output');
  const $title = $modal.find('.modal-title');
  if ($sourceEl.length > 0) {
    $output.html($sourceEl.html());
    $title.html(modalTitle);
    $modal.modal('show');
  } else {
    $.ajax({
      type: 'GET',
      url: sourceID,
      success: function (data) {
        $output.html(data);
        $title.html(modalTitle);
        $modal.modal('show');
      },
      error: function () {
        $output.html('<p>読み込みに失敗しました。</p>');
        $modal.modal('show');
      }
    });
  }
  // モーダルを閉じたときに内容をクリアする（毎回バインドしないように1回だけ）
  if (!$modal.data('clear-handler-set')) {
    $modal.on('hidden.bs.modal', function () {
      $output.empty();
    });
    $modal.data('clear-handler-set', true); // 二重バインド防止
  }
};


/////////////////////////////////////////////
// 〒番号自動補完
//<?php /*https://github.com/ajaxzip3/ajaxzip3.github.io?tab=readme-ov-file*/ ?>
//<script src="https://ajaxzip3.github.io/ajaxzip3.js" charset="UTF-8"></script>
/////////////////////////////////////////////
// function contactZip() {
// $('[name="contact-zip"]').on('keyup', function() {
// console.log("keyup fired");
// AjaxZip3.zip2addr(this, '', 'contact-addr', 'contact-addr');
// });
// }
// document.addEventListener('DOMContentLoaded', () => {
// });

/////////////////////////////////////////////
//
/////////////////////////////////////////////
function navToggle() {
  const $navTrigger = $('#btn06');
  const $body = $('body');
  $navTrigger.on('click', function () {
    if ($body.hasClass('nav-open')) {
      // 閉じる
      $body.removeClass('nav-open').addClass('nav-close');
    } else {
      // 開く
      $body.addClass('nav-open').removeClass('nav-close');
    }
  });
}

//////////////////////////////
// 
/////////////////////////////
registerChartTheme01();

//////////////////////////////
// WINDOW LOAD
/////////////////////////////
$(function(){
  navToggle();
  // contactZip();
  initMarquee();
  initSlotNumber();
  // ページ読み込み時に一括初期化
  initGsapAnimations({
    start: 'top 90%',
    once: true,
    duration: 0.8,
    ease: 'power3.out',
  });


////////////////////////////////////
//NAV MENU (.type_tel)//FORMをinput type = telにする
////////////////////////////////////
  document.querySelectorAll('input.type_tel').forEach(function(el) {
    el.type = 'tel'; // ←これが確実
  });


/////////////////////////////
///
////////////////////////////
  // 初回・Ajax再描画対応
  hideTipsOnAction(); // ← 初期化呼び出し
  document.addEventListener("wpcf7invalid", hideTipsOnAction);

  function hideTipsOnAction() {
    // クリックでエラーを消す
    $(document).on("click", ".wpcf7-not-valid-tip", function () {
      $(this).fadeOut(150);
    });

    // フォーカス時に該当フィールドのエラーを消す
    $(document).on("focus", ".wpcf7-form-control", function () {
      $(this).closest(".wpcf7-form-control-wrap")
        .find(".wpcf7-not-valid-tip")
        .fadeOut(150);
    });
  }


////////////////////////////////////
//NAV MENU
////////////////////////////////////
//  gsap.fromTo("#sw-top-mv", 
//   {
//     // y: 0,
//     // scale: 1,
//     // rotation: 0,
//     filter: "blur(0px)",
//     // filter: "brightness(1)" 
//   }, 
//   {
//     // y: 260,
//     // scale: 1.8, 
//     filter: "blur(15px)",
//     // filter: "brightness(0.2)", 
//     ease: "none",
//     scrollTrigger: {
//       trigger: "#sw-top-mv",
//       start: "top top",
//       end: "bottom top",
//       scrub: 0.5
//     }
//   }
// );


////////////////////////////////////
//BUGERMENU
////////////////////////////////////
$('.btn-trigger').on('click', function() {
  $(this).toggleClass('active');
  return false;
});
$('.js-btn-clickmenu').on("click",function(){
    $('#btn06').click();
})

$(document).on("click", ".js-btn-bs_modalclose", function (e) {
  var $modal = $(this).closest(".modal");
  if ($modal.length) {
    var modalEl = $modal[0];
    var modalInstance = bootstrap.Modal.getInstance(modalEl);
    if (modalInstance) {
      modalInstance.hide();
    }
  }
});


////////////////////////////////////
//
////////////////////////////////////
$('.js-number').attr("inputmode", "tel");
$('.js-number').on('input', function() {
    // 全角数字を半角に変換
    var convertedValue = $(this).val().replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    $(this).val(convertedValue);
});


///////////////////////////////
// スクロール判定　nav-side
///////////////////////////////
var headerH = $("#header").outerHeight(true); // headerの高さを取得
function toggleHeaderClass() {
  $('body').toggleClass('is_scrollstart', $(window).scrollTop() >= headerH);
}
$(window).scroll(toggleHeaderClass);
$(window).on('load', toggleHeaderClass);
  
/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
// window.App.loadSection = function(url, modalId,modalTitle) {
//   $.ajax({
//     type: 'GET',
//     url: url,
//     success: function(data) {
//       $(modalId).find(".ajx_content_output").html(data);
//       $(modalId).find('.modal-title').html(modalTitle);
//       $(modalId).modal('show');
//     }
//   });
// };

//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }

  // メニュー側 Swiper
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    spaceBetween: 0,
    allowSlideNext: false,
    allowSlidePrev: false,
    watchSlidesProgress: true, // thumbs の同期を軽量化
    // observer: true, // 不要なので無効
    // observeParents: true,
  });

  // メイン側 Swiper
  var mainSwiper = new Swiper(containerId, {
    loop: true, // PC/SP共通
    spaceBetween: 0,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
    lazy: {
      loadOnTransitionStart: true,
      loadPrevNext: true,
      loadPrevNextAmount: 1, // 負荷軽減
    },
    clickable: true,
    // observer: true, // 不要
    // observeParents: true,
  });
};


///////////////////////////////
// SWITCH BUTTON OPEN ALL
///////////////////////////////
$(".toggle").on("click", function() {
  $(this).toggleClass("checked");
  var isChecked = !$(this).find('input[name="check"]').prop("checked");
  $(this).find("input").prop("checked", isChecked);

  // data-target の取得
  var targetSection = $(this).attr("data-target");

  // 該当の section 内の dt 要素を操作
  $("#" + targetSection).find("dt").each(function() {

      if (isChecked) {
          $(this).parent('dl').attr("aria-expanded", "true");
          $(this).next("dd").slideDown(300);
      } else {
          $(this).parent('dl').attr("aria-expanded", "false");
          $(this).next("dd").slideUp(300);
      }
  });
});

///////////////////////////////////////////////////////////
//FAQ ETC
//////////////////////////////////////////////////////////////
$(".lst-slidedown").find("li").on("click", function(){
  if ($(this).hasClass("shown")) {
    $(this).removeClass("shown");
  } else {
    $(this).addClass("shown");
  }
});

///////////////////////////////
// SLIDE-DOWN
///////////////////////////////
$(".item-slidedown dt").on("click", function(e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  var parent = $(this).closest(".item-slidedown");
  var answer = parent.find("dd");
  var isOpen = parent.attr("aria-expanded") === "true";

  if (isOpen) {
    parent.attr("aria-expanded", "false");
    answer.slideUp(300);
  } else {
    parent.attr("aria-expanded", "true");
    answer.slideDown(300);
  }
});

// dd 内をクリックしても親要素のイベントを発火させない
$(".item-slidedown dd").on("click", function(e) {
  e.stopPropagation();
});

/////////////////////////////////////
// TXT ANIMATION 左右バー
/////////////////////////////////////
gsap.utils.toArray('.an-lr, .an-rl').forEach(el => {
  const $el = $(el);
  const $i = $el.find('i');
  const isRight = $el.hasClass('an-rl');
  if (!$i.length) return; // 子要素なければスキップ
  gsap.set($i, {
    width: '0%',
    left: isRight ? 'auto' : '0%',
    right: isRight ? '0%' : 'auto',
  });
  gsap.to($i, {
    width: '100%',
    duration: 0.4,
    ease: 'none',
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      toggleActions: 'play none none none',
      once: true,
    }
  });
});

/////////////////////////////////////
// アイコンスライド（左右に動かしてフェード）
/////////////////////////////////////
const moveTargets = gsap.utils.toArray(".an-move-h");
if (moveTargets.length) {
  gsap.fromTo(moveTargets,
    { x: 0, opacity: 0 },
    { 
      x: -50,
      duration: 2,
      repeat: -1,
      ease: "power1.in",
      onUpdate: function () {
        const progress = this.progress(); // 0〜1
        const midOpacity = 1 - Math.abs(progress - 0.5) * 2;
        gsap.set(moveTargets, { opacity: midOpacity });
      }
    }
  );
}

/////////////////////////////////////
// マスクスライド
/////////////////////////////////////
gsap.utils.toArray('.mask-lr, .mask-rl').forEach(el => {
  const $el = $(el);
  const isRight = $el.hasClass('mask-rl');
  const $wrap = $el.find('.mask-wrap');
  const $content = $el.find('.mask-content');
  if (!$wrap.length || !$content.length) return;
  // 動的にバー追加
  const $bar = $('<span class="mask-bar"></span>');
  $wrap.append($bar);
  // 初期設定
  gsap.set($bar, { x: 0 });
  gsap.set($content, { opacity: 0, x: isRight ? -20 : 20 });
  // アニメーション
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      toggleActions: 'play none none none',
      once: true,
    }
  });
  tl.to($bar, {
    x: isRight ? '100%' : '-100%',
    duration: 0.5,
    ease: 'power2.out'
  }).to($content, {
    opacity: 1,
    x: 0,
    duration: 0.3,
    ease: 'power2.out'
  }, '-=0.3');
});

/////////////////////////////////////
// clip-mask
/////////////////////////////////////
gsap.utils.toArray('.an-clip-mask').forEach(el => {
  ScrollTrigger.create({
    trigger: el,
    start: 'top 80%',
    once: true,
    onEnter: () => el.classList.add('is-active')
  });
});
});



/////////////////////////////////////
// BLOCK ANIMATION
// .acc-sq01 {
//   background-color: #ccc; /* グレー */
//   display: block;
//   will-change: transform;
// }
// .an-sq-rl {
//   transform-origin: right;
// }
// .an-sq-lr {
//   transform-origin: left;
// }
// .an-sq-tb {
//   transform-origin: top;
// }
// .an-sq-bt {
//   transform-origin: bottom;
// }
//an-sq-sync //sunc
/////////////////////////////////////

// $('.an-sq-lr, .an-sq-rl, .an-sq-tb, .an-sq-bt').each(function () {
//   const $el = $(this);

//   // 初期設定
//   let fromVars = { scaleX: 0, transformOrigin: 'left center' };
//   let toVars = { scaleX: 1, ease: 'power2.out' };

//   if ($el.hasClass('an-sq-rl')) {
//     fromVars.transformOrigin = 'right center';
//   }
//   if ($el.hasClass('an-sq-tb')) {
//     fromVars = { scaleY: 0, transformOrigin: 'top center' };
//     toVars = { scaleY: 1, ease: 'power2.out' };
//   }
//   if ($el.hasClass('an-sq-bt')) {
//     fromVars = { scaleY: 0, transformOrigin: 'bottom center' };
//     toVars = { scaleY: 1, ease: 'power2.out' };
//   }

//   const isSync = $el.hasClass('an-sq-sync');

//   // 初期状態
//   gsap.set($el[0], fromVars);

//   // アニメーション
//   gsap.to($el[0], {
//     ...toVars,
//     scrollTrigger: {
//       trigger: $el[0],
//       start: 'top bottom',
//       end: 'bottom top',
//       scrub: isSync ? 1 : false, // スクロール同期 or 単発再生
//       toggleActions: isSync ? 'none none none none' : 'play none none none',
//       // markers: true,
//     }
//   });
// });
////////////////////////
// 
////////////////////////
// window.addEventListener('load', () => ScrollTrigger.refresh());
// // window.addEventListener('resize', () => ScrollTrigger.refresh());
// gsap.registerPlugin(ScrollTrigger);
// function formatValue(value, useComma = false, useDecimal = false) {
//   const parts = value.toString().split('.');
//   let intPart = parts[0];
//   let decPart = parts[1] || '';
//   if (useComma) {
//     intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   }
//   return useDecimal && decPart ? intPart + '.' + decPart : intPart;
// }

////////////////////////
// REISZE ANIME
////////////////////////
// let slotInitialized = false;
// let lastWindowWidth = window.innerWidth;

// function resetSlotNumbers() {
//   ScrollTrigger.getAll().forEach(t => t.kill());
//   $('.num-slot').empty();
//   initSlotNumber();
// }

// function debounce(func, delay) {
//   let timer;
//   return () => {
//     clearTimeout(timer);
//     timer = setTimeout(func, delay);
//   };
// }
//   slotInitialized = true;
//   const onResize = debounce(() => {
//   const nowW = window.innerWidth;
//   // 横幅だけで判断（スマホでのinnerHeight変化は無視）
//   if (nowW === lastWindowWidth) return;
//   lastWindowWidth = nowW;
//   if (slotInitialized) resetSlotNumbers();
//   }, 300);
//   window.addEventListener('resize', onResize);



